export const discordUrl = "https://discord.com/invite/SYM34MF9yR"